import { getUnixTime } from "date-fns/esm";
import { NetworkStatus } from "@apollo/client";

import useGetTimeToRecoveryAverage from "shared/DoraMetrics/useGetTimeToRecoveryAverage";

import useDoraDateRange from "../useDateRange";

const useDoraTimeToRecoveryAverage = () => {
  const { startTime, endTime } = useDoraDateRange();

  const { averageSeconds, loading, error, networkStatus } = useGetTimeToRecoveryAverage({
    startTimeUnix: getUnixTime(startTime),
    endTimeUnix: getUnixTime(endTime),
  });

  const isLoading =
    (loading && typeof averageSeconds === "undefined") || networkStatus === NetworkStatus.refetch;

  return {
    averageSeconds,
    isLoading,
    error,
  };
};

export default useDoraTimeToRecoveryAverage;
